<div [attr.data-tf-live]="typeFormData()">
  <div class="loading-wrapper">
    <ush-loading-indicator [fontSize]="'2rem'" [color]="'inherit'" />
  </div>
</div>
